import type { ImageFormat } from "fabric";
import { IMAGE_RESOURCE_TYPE, VIDEO_RESOURCE_TYPE } from "../constants.ts";
import type { ResourceType } from "../types.ts";
import { designerCanvasStore } from "../Workspaces/EditWorkspace/Designer/stores/designerCanvasStore.ts";
import {
  buildCanvasWithImageContent,
  buildCanvasWithVideoContent,
} from "../Workspaces/EditWorkspace/Designer/utils/export.ts";

export const useCompileEditionCanvas = () => {
  const { fabricCanvas, canvasSize, backgroundColor } =
    designerCanvasStore.useState();

  return fabricCanvas
    ? (
        url: string,
        type: ResourceType,
        imageFormat: ImageFormat = "png",
        quality = 1,
      ) => {
        if (!canvasSize) throw new Error("Canvas size is not set");
        if (!backgroundColor) throw new Error("Background color is not set");
        switch (type) {
          case IMAGE_RESOURCE_TYPE:
            return buildCanvasWithImageContent(
              fabricCanvas,
              canvasSize,
              url,
              imageFormat,
              quality,
            );
          case VIDEO_RESOURCE_TYPE:
            return buildCanvasWithVideoContent(
              fabricCanvas,
              canvasSize,
              backgroundColor,
              url,
            );
        }
      }
    : undefined;
};
